import React from 'react';

export default function LightSpinnerWrapper({children, customClasses, isLoading, sizeLarge}) {
    return (
        <div className={"spinner-wrapper" +
                        (sizeLarge ? " large " : " ") +
                        (isLoading ? " loading" : " loaded") +
                        (customClasses ? ' ' + customClasses : '')}>
            <div className={"spinner-wrapper__content" + (isLoading ? " visibility-hidden" : " visibility-shown")}>
                {children}
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Wrappers/LightSpinnerWrapper/LightSpinnerWrapper.jsx